export interface IGlobalVariables {}

export const GlobalVariables: IGlobalVariables = {};

export const setConfig = () => {
  // GlobalVariables.config = config
};

export const getConfig = () => {
  // return GlobalVariables.config
};

// Release mode, mirroring 1.0's getMode(): it selects which `externalScript`
// block (dev / staging / main) gets injected, so the Adobe Launch property and
// consent scripts match the environment. 1.0 read process.env.linkType; the
// Vite equivalent is VITE_LINK_TYPE, and an unset value means dev.
export type ReleaseMode = 'dev' | 'staging' | 'main';

export const getMode = (): ReleaseMode => {
  // Read straight off import.meta.env, NOT through a cast or optional chain:
  // Vite only substitutes the build-time value when it sees the literal member
  // access, and `import.meta.env` is not a real runtime object in a built
  // bundle. src/vite-env.d.ts declares the var so this still type-checks.
  const branch = import.meta.env.VITE_LINK_TYPE ?? 'dev';
  if (branch.includes('main')) return 'main';
  if (branch.includes('staging')) return 'staging';
  return 'dev';
};

// Which of the three published release channels the graphics engine should
// resolve every SKU against. 1.0 has the same switch in its own globals.ts
// (getVersion): the asset pipeline promotes a SKU alpha -> beta -> gamma, so a
// dev build must read alpha (newest, what artists just published), staging
// beta, and only production gamma. 2.0 previously fell back to
// `import.meta.env.DEV ? alpha : gamma`, which is true only under `vite serve`
// - so every *deployed* build, dev links included, asked for gamma and showed
// stale assets.
export const getVersion = (): 'alphaVersion' | 'betaVersion' | 'gammaVersion' => {
  switch (getMode()) {
    case 'staging':
      return 'betaVersion';
    case 'main':
      return 'gammaVersion';
    default:
      return 'alphaVersion';
  }
};
